import { Check } from 'lucide-react'
import { ReactNode } from 'react'

import { cn } from '../../utils/cn'
import { Card, CardContent } from './card'

interface CardRadioProps {
  isSelected: boolean
  onSelect: () => void
  children: ReactNode
  className?: string
  contentClassName?: string
  disabled?: boolean
  /** Green "complete" variant (e.g. this option already has data) — shows a check. */
  green?: boolean
}

/** Single-select sibling of CardCheckbox: a clickable card with a radio indicator. */
export function CardRadio({
  isSelected,
  onSelect,
  children,
  className,
  contentClassName,
  disabled,
  green,
}: CardRadioProps) {
  return (
    <Card
      className={cn(
        'border-input px-1 py-3 shadow-none transition-colors',
        disabled ? 'opacity-50' : 'cursor-pointer',
        green
          ? 'border-green-500 bg-green-50'
          : isSelected
            ? 'border-ink-700'
            : !disabled && 'hover:border-ink-300',
        className
      )}
      onClick={() => !disabled && onSelect()}
    >
      <CardContent className="px-4">
        <div className={cn('flex items-center justify-between gap-4', contentClassName)}>
          <div
            className={cn('text-md flex-1 font-semibold md:text-sm', green ? 'text-green-800' : 'text-black')}
          >
            {children}
          </div>
          <div className="flex shrink-0 items-center gap-2">
            {green && <Check className="size-5 shrink-0 text-green-600" />}
            <span
              className={cn(
                'flex size-5 shrink-0 items-center justify-center rounded-full border',
                isSelected ? 'border-ink-700' : 'border-neutral-300'
              )}
            >
              {isSelected && <span className="bg-ink-700 size-2.5 rounded-full" />}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
